import React, {useEffect, useState} from "react"
import ReactDOM from "react-dom"

/**
 * Use this component to render anything into TopToolbar area
 */

export const TopToolbarInjector = ({ children }) => {
  const [wrapperElement] = useState<HTMLDivElement>(() => {
    const topToolbarElement = document.querySelector("#actions-buttons-region") || document.createElement("div")
    const element = document.createElement("div")
    topToolbarElement.append(element)

    return element
  })
  const Wrapper = () => (
    <React.Fragment>
        {children}
    </React.Fragment>
  )

  useEffect(() => {
    return () => {
      ReactDOM.unmountComponentAtNode(wrapperElement as HTMLElement)
      wrapperElement.remove()
    }
  }, [])

  useEffect(() => {
    const topToolbarElement = document.querySelector("#actions-buttons-region")

    if (topToolbarElement && !topToolbarElement.contains(wrapperElement)) topToolbarElement.append(wrapperElement)

    ReactDOM.render(
      // @ts-ignore
      React.createElement(Wrapper),
      wrapperElement
    )
  }, [children])

  return <></>
}